const mutations = {
  /**
   * Sets AppMessage on the AppMessageView.
   */
  view(state, { message, reportKey }) {
    const { defaults } = state
    const view = { ...defaults, ...message }

    state.views = { ...state.views, [reportKey]: view }
  },
}

export default mutations
